var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control"},[_c('kst-button',{staticClass:"is-primary",attrs:{"action-mode":"","fullLabel":"","module":_vm.Model.Module,"moduleType":_vm.Model.ModuleType.New}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }